// Fixed green-600 rather than a role: the white stroke drawn over the money icon needs a fill that
// stays dark enough in both themes, and --success-default lightens too far in dark.
export const MONEY_ICON_FILL = `oklch(62.7% 0.194 149.214)`
